export var TABLET_BREAKPOINT = 600;